module.exports = __webpack_public_path__ + "static/img/sc_0@2x.600db56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc_0@2x.png
// module id = H6/q
// module chunks = 1